import { format, isToday } from 'date-fns';
import styled from 'styled-components';

interface DayCellProps {
  date: Date;
  isOutsideMonth: boolean;
}

export default function DayCell({ date, isOutsideMonth }: DayCellProps) {
  const dayNumber = format(date, 'd');
  const isCurrentDay = isToday(date);

  return (
    <Container $isOutsideMonth={isOutsideMonth} data-cy='day-cell'>
      <DayNumberWrapper>
        <DayNumber $isToday={isCurrentDay} $isOutsideMonth={isOutsideMonth}>
          {dayNumber}
        </DayNumber>
      </DayNumberWrapper>
      <ContentArea>{/* Patient cards will be rendered here in future */}</ContentArea>
    </Container>
  );
}

const Container = styled.div<{ $isOutsideMonth: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100px;
  padding: 8px;
  border-right: 1px solid ${({ theme }) => theme.colors.black10};
  border-bottom: 1px solid ${({ theme }) => theme.colors.black10};
  background-color: ${({ $isOutsideMonth, theme }) => ($isOutsideMonth ? theme.colors.black05 : theme.colors.white)};

  &:nth-child(7n) {
    border-right: none;
  }
`;

const DayNumberWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const DayNumber = styled.span<{ $isToday: boolean; $isOutsideMonth: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  font-size: 12px;
  font-weight: ${({ $isToday }) => ($isToday ? 'var(--font-weight-bold)' : 'var(--font-weight-medium)')};
  color: ${({ $isOutsideMonth, $isToday, theme }) => {
    if ($isToday) return theme.colors.white;
    if ($isOutsideMonth) return theme.colors.black50;
    return theme.colors.black;
  }};
  background-color: ${({ $isToday, theme }) => ($isToday ? theme.colors.primaryBlue : 'transparent')};
  border-radius: 50%;
`;

const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`;
